import { isEmpty } from 'lodash';
import ExternalAudienceTargetingType from '../../campaigns/modules/common-campaign-form/config/ExternalAudienceTargetingType';
import TargetingTypes from '../../campaigns/modules/common-campaign-form/config/TargetingTypes';
import { getAudiencesByTargetingType } from '../../campaigns/services/transformers/audienceTransformerUtils';
import { AUDIENCE_TYPE } from '../config';
import { buildMRTGroup } from './domainsTransformer';

export const externalAudiencesTransformerToGW = audience => {
    const { domains = {}, keywords = [], type, ...rest } = audience;
    const collection = [];

    const createSRTTargetingValue = (targetingType, valueType, values) => ({
        type: targetingType,
        values: [
            {
                type: valueType,
                values,
            },
        ],
    });

    if (type === AUDIENCE_TYPE.SEARCH_KEYWORDS) {
        if (!isEmpty(keywords)) {
            collection.push(
                createSRTTargetingValue(TargetingTypes.INCLUDE, ExternalAudienceTargetingType.SRT_KEYWORDS, keywords)
            );
        }
    }

    if (type === AUDIENCE_TYPE.MAIL_DOMAINS) {
        if (domains.include?.length) {
            collection.push(buildMRTGroup(domains.include, TargetingTypes.INCLUDE));
        }
        if (domains.exclude?.length) {
            collection.push(buildMRTGroup(domains.exclude, TargetingTypes.EXCLUDE));
        }
    }

    return {
        ...rest,
        ...(collection && collection.length > 0 ? { targetingValues: { collection } } : {}),
        segmentType: type,
        isArchived: rest.status === 'ARCHIVED',
    };
};

export const externalAudiencesTransformerFromGW = audience => {
    const { targetingValues = {}, segmentType } = audience;

    const getTargetingValues = (targetingType, valueType) => {
        const segments = getAudiencesByTargetingType(targetingValues?.collection, targetingType);
        const matchingSegments = segments?.find(v => v.type === valueType);
        return matchingSegments?.values || [];
    };

    let targetingObj = {};
    if (segmentType === AUDIENCE_TYPE.SEARCH_KEYWORDS) {
        targetingObj = {
            keywords: getTargetingValues(TargetingTypes.INCLUDE, ExternalAudienceTargetingType.SRT_KEYWORDS),
        };
    }

    if (segmentType === AUDIENCE_TYPE.MAIL_DOMAINS) {
        targetingObj = {
            domains: {
                include: [
                    ...getTargetingValues(TargetingTypes.INCLUDE, ExternalAudienceTargetingType.MRT_DOMAINS),
                    ...getTargetingValues(TargetingTypes.INCLUDE, ExternalAudienceTargetingType.MRT_CATEGORIES),
                ],
                exclude: [
                    ...getTargetingValues(TargetingTypes.EXCLUDE, ExternalAudienceTargetingType.MRT_DOMAINS),
                    ...getTargetingValues(TargetingTypes.EXCLUDE, ExternalAudienceTargetingType.MRT_CATEGORIES),
                ],
            },
        };
    }

    return {
        ...audience,
        ...targetingObj,
        type: segmentType,
    };
};
